/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  IconButton,
  TextField,
  Button,
  Box,
  Grid,
  Alert,
  CircularProgress,
  Chip,
  Autocomplete,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Avatar,
} from '@mui/material';
import { fetcher, postFetcher } from 'src/utils/axios';
import { enqueueSnackbar } from 'notistack';
import QuantityWarningDialog from './warningDialog';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { useInventory } from 'src/context/inventory-create-provider';

const toISO = (date, time) => (date && time ? `${date}T${time}:00Z` : '');

// ── Icons ────────────────────────────────────────────────────────────────────
const IconClose = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);
const IconSettings = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M9 1v2M9 15v2M1 9h2M15 9h2M3.2 3.2l1.4 1.4M13.4 13.4l1.4 1.4M14.8 3.2l-1.4 1.4M4.6 13.4l-1.4 1.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const IconNodes = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <rect x="1" y="1" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="11" y="1" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="6" y="11" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M4 7v2.5a.5.5 0 00.5.5H9M14 7v2.5a.5.5 0 01-.5.5H9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const IconPlus = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);
const IconPreview = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.4"/>
  </svg>
);

// ── Sidebar nav items ────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: 'details',   label: 'Job Details',  icon: <IconSettings /> },
  { id: 'nodes',     label: 'Nodes',        icon: <IconNodes /> },

];

// ── Styles ───────────────────────────────────────────────────────────────────
const SIDEBAR_W = 200;

const sidebarStyle = {
  width: SIDEBAR_W,
  minWidth: SIDEBAR_W,
  borderRight: '1px solid #E5E7EB',
  backgroundColor: '#F9FAFB',
  display: 'flex',
  flexDirection: 'column',
  pt: 1,
  pb: 2,
};

const navItemStyle = (active) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 2.5,
  py: 1.25,
  cursor: 'pointer',
  borderRadius: '8px',
  mx: 1,
  mb: 0.5,
  transition: 'all 0.15s ease',
  backgroundColor: active ? '#111827' : 'transparent',
  color: active ? '#fff' : '#6B7280',
  '&:hover': {
    backgroundColor: active ? '#111827' : '#F3F4F6',
    color: active ? '#fff' : '#374151',
  },
});

const sectionLabelStyle = {
  px: 2.5,
  py: 1,
  fontSize: '10px',
  fontWeight: 700,
  letterSpacing: '0.08em',
  color: '#9CA3AF',
  textTransform: 'uppercase',
};

const cardStyle = {
  border: '1px solid #E5E7EB',
  borderRadius: '10px',
  boxShadow: 'none',
  mb: 2,
  overflow: 'hidden',
};

const cardHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 2.5,
  py: 1.5,
  borderBottom: '1px solid #F3F4F6',
  backgroundColor: '#FAFAFA',
};

const sectionTitleStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '0.06em',
  color: '#374151',
  textTransform: 'uppercase',
};

// ── Main Component ────────────────────────────────────────────────────────────
export default function JobDialog({
  handleCloseJobDialog,
  workflowId,
  JobDialogOpen,
  jobData = null,
  onJobSaved = () => {},
  nodeIds = [],
  nodesData = [],
  defaultJobName = '',
}) {
  console.log(nodesData, nodeIds);

  const [activeSection, setActiveSection] = useState('details');
  const {updatejobpayload}=useInventory()
  const [form, setForm] = useState({
    name: defaultJobName || '',
    productCreationId: null,
    status: 'scheduled',
  });

  useEffect(() => {
    if (JobDialogOpen) {
      if (jobData?.name) {
        setForm((prev) => ({ ...prev, name: jobData.name }));
      } else if (defaultJobName) {
        setForm((prev) => ({ ...prev, name: defaultJobName }));
      }
    }
  }, [JobDialogOpen, jobData, defaultJobName]);
  const [nodeMachineRows, setNodeMachineRows] = useState({});
  console.log('nodemachinerow', nodeMachineRows);

  const router = useRouter();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [saveError, setSaveError] = useState('');
  const [jobId, setjobId] = useState(null);
  const [productVariants, setProductVariants] = useState([]);
  const [loadingVariants, setLoadingVariants] = useState(false);
  const [schedulingMode, setSchedulingMode] = useState('manual');
  const [allNodeData, setAllNodeData] = useState({});
  const [allSubmachines, setAllSubmachines] = useState({});
  const [loadingSubmachines, setLoadingSubmachines] = useState({});
  const [inventoryReport, setInventoryReport] = useState([]);
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [warningData, setWarningData] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  // ── Fetch all nodes ──────────────────────────────────────────────────────
  const fetchAllNodesData = async () => {
    if (!nodeIds.length) return;
    const nodeDataMap = {};
    const promises = nodeIds.map(async (nodeId) => {
      try {
        const res = await fetcher([`new/workflow-app/node/${nodeId}/`]);
        console.log('res', res);
        nodeDataMap[nodeId] = res.data || res;
      } catch (e) {
        console.error(`Error fetching node ${nodeId}:`, e);
        nodeDataMap[nodeId] = null;
      }
    });
    await Promise.all(promises);
    setAllNodeData(nodeDataMap);
    return nodeDataMap;
  };

  useEffect(() => {
    if (JobDialogOpen && nodeIds.length > 0) fetchAllNodesData();
  }, [JobDialogOpen, nodeIds]);

  // ── Fetch submachines ────────────────────────────────────────────────────
  const fetchAllSubmachines = async (nodeDataMap) => {
    if (!nodeDataMap) return;
    const allSubmachinesMap = {};
    const loadingMap = {};
    nodeIds.forEach((nodeId) => { loadingMap[nodeId] = true; });
    setLoadingSubmachines(loadingMap);
    const allPromises = nodeIds.map(async (nodeId) => {
      const nodeData = nodeDataMap[nodeId];
      if (!nodeData?.machine?.length) { allSubmachinesMap[nodeId] = []; return; }
      const machineIds = nodeData.machine.map((m) => m.id);
      const nodeSubmachines = [];
      for (const mid of machineIds) {
        const payload = { machine_master_ids: [mid] };
        try {
          const subRes = await postFetcher(['factoryLayout-app/machine/from/machine-master/', payload]);
          const subData = subRes.data || subRes;
          nodeSubmachines.push(...(subData.submachines || subData || []));
        } catch (err) {
          console.error(`submachines for node ${nodeId}, machine ${mid}:`, err);
        }
      }
      allSubmachinesMap[nodeId] = nodeSubmachines;
    });
    await Promise.all(allPromises);
    setAllSubmachines(allSubmachinesMap);
    const resetLoadingMap = {};
    nodeIds.forEach((nodeId) => { resetLoadingMap[nodeId] = false; });
    setLoadingSubmachines(resetLoadingMap);
  };

  useEffect(() => {
    if (Object.keys(allNodeData).length > 0) fetchAllSubmachines(allNodeData);
  }, [allNodeData]);

  // ── Initialise machine rows ──────────────────────────────────────────────
  useEffect(() => {
    if (Object.keys(allNodeData).length === 0) return;
    const allMachineRows = {};
    nodeIds.forEach((nodeId) => {
      const nodeData = allNodeData[nodeId];
      if (nodeData?.type === 'diamond' && (!nodeData?.machine || nodeData.machine.length === 0)) {
        allMachineRows[nodeId] = [{ node_id: nodeId, machine_id: null, machine_name: `${nodeData.name} (Diamond - No Machine)`, submachines: [], quantity: [], priority: 'medium', status: 'scheduled', is_diamond_node: true, diamond_status: 'unapproved' }];
        return;
      }
      if (nodeData?.type === 'default' && (!nodeData?.machine || nodeData.machine.length === 0)) {
        allMachineRows[nodeId] = [{ node_id: nodeId, machine_id: null, machine_name: `${nodeData.name} (Default - No Machine)`, submachines: [], quantity: [], priority: 'medium', status: 'scheduled', is_default_node: true }];
        return;
      }
      if (!nodeData?.machine?.length) { allMachineRows[nodeId] = []; return; }
      const rows = nodeData.machine.map((m) => ({ node_id: nodeId, machine_id: m.id, machine_name: m.name, submachines: [], quantity: [], priority: 'medium', status: 'scheduled', fallback: m.fallback, is_diamond_node: false, is_default_node: false }));
      allMachineRows[nodeId] = rows;
    });
    setNodeMachineRows(allMachineRows);
  }, [allNodeData, nodeIds]);

  // ── Product variants ─────────────────────────────────────────────────────
  useEffect(() => {
    if (!JobDialogOpen) return;
    const load = async () => {
      setLoadingVariants(true);
      try {
        const res = await fetcher('/api/product-variants');
        setProductVariants(res.data || []);
      } catch (e) { console.error(e); }
      finally { setLoadingVariants(false); }
    };
    load();
  }, [JobDialogOpen]);

  // ── Handlers ─────────────────────────────────────────────────────────────
  const handleFormChange = (field) => (e) => {
    setForm((p) => ({ ...p, [field]: e.target.value }));
    errors[field] && setErrors((p) => ({ ...p, [field]: '' }));
  };

  const updateRow = (nodeId, idx, field, value) => {
    setNodeMachineRows((prev) => ({ ...prev, [nodeId]: prev[nodeId].map((r, i) => (i === idx ? { ...r, [field]: value } : r)) }));
  };

  const handleSubmachinesChange = (nodeId, idx, _, newValue) => {
    const quantityArray = newValue.map((submachine) => ({ max_value: '', machine_id: submachine.machine_id }));
    updateRow(nodeId, idx, 'submachines', newValue);
    updateRow(nodeId, idx, 'quantity', quantityArray);
  };

  const handleQuantityChange = (nodeId, rowIdx, submachineIdx, value) => {
    setNodeMachineRows((prev) => {
      const newRows = { ...prev };
      const row = newRows[nodeId][rowIdx];
      const newQuantity = [...row.quantity];
      if (newQuantity[submachineIdx]) {
        newQuantity[submachineIdx] = { ...newQuantity[submachineIdx], max_value: value };
      } else {
        const submachine = row.submachines[submachineIdx];
        if (submachine) newQuantity[submachineIdx] = { max_value: value, machine_id: submachine.machine_id };
      }
      newRows[nodeId][rowIdx] = { ...row, quantity: newQuantity };
      return newRows;
    });
  };

  // ── Validation ───────────────────────────────────────────────────────────
  const validate = () => {
    const err = {};
    if (!form.name.trim()) err.name = 'Job name is required';
    Object.entries(nodeMachineRows).forEach(([nodeId, rows]) => {
      rows.forEach((row, rowIndex) => {
        if (row.is_diamond_node || row.is_default_node) return;
        row.quantity.forEach((qty, qtyIndex) => {
          if (!qty.max_value || isNaN(qty.max_value) || parseInt(qty.max_value) <= 0) {
            err[`quantity_${nodeId}_${rowIndex}_${qtyIndex}`] = `Valid quantity required for ${row.submachines[qtyIndex]?.machine_label || 'submachine'}`;
          }
        });
      });
    });
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // ── Build payloads ───────────────────────────────────────────────────────
  const buildPayload = () => {
    const allJobMachines = [];
    Object.entries(nodeMachineRows).forEach(([nodeId, rows]) => {
      const nodeInfo = nodesData.find((n) => n.id === parseInt(nodeId, 10)) || {};
      const nodeData = allNodeData[nodeId];
      const fetch_list_ids = nodeInfo.fetch_list_ids || [];
      rows.forEach((row) => {
        const fallbackId = nodeData?.fallback;
        if (row.is_diamond_node) {
          const diamondEntry = { node_id: row.node_id, machine_master_id: null, machine_ids: [], quantity: [], priority: row.priority, status: row.status, fetch_list_ids, diamond_status: 'unapproved' };
          if (fallbackId) diamondEntry.fallback_data = [{ fallback_ids: [fallbackId] }];
          allJobMachines.push(diamondEntry);
        } else if (row.is_default_node) {
          allJobMachines.push({ node_id: row.node_id, machine_master_id: null, machine_ids: [], quantity: [], priority: row.priority, fetch_list_ids, status: 'scheduled' });
        } else {
          allJobMachines.push({ node_id: row.node_id, machine_master_id: row.machine_id, machine_ids: row.submachines.map((s) => s.machine_id), quantity: row.quantity, priority: row.priority, fetch_list_ids, status: row.status });
        }
      });
    });
    return { workflow_creation_id: workflowId, name: form.name.trim(), status: form.status, job_machines: allJobMachines };
  };

  const AutobuildPayload = () => {
    const allJobMachines = [];
    Object.entries(nodeMachineRows).forEach(([nodeId, rows]) => {
      const nodeInfo = nodesData.find((n) => n.id === parseInt(nodeId, 10)) || {};
      const nodeData = allNodeData[nodeId];
      const fetch_list_ids = nodeInfo.fetch_list_ids || [];
      rows.forEach((row) => {
        const fallbackId = nodeData?.fallback;
        if (row.is_diamond_node) {
          const entry = { node_id: row.node_id, machine_master_id: null, machine_ids: [], quantity: [], priority: row.priority, status: row.status, fetch_list_ids, machine_status: 'scheduled', diamond_status: 'unapproved' };
          if (fallbackId) entry.fallback_data = [{ fallback_ids: [fallbackId] }];
          allJobMachines.push(entry);
        } else if (row.is_default_node) {
          allJobMachines.push({ node_id: row.node_id, machine_master_id: null, machine_ids: [], quantity: [], priority: row.priority, fetch_list_ids, status: 'scheduled', machine_status: 'scheduled' });
        } else {
          allJobMachines.push({ node_id: row.node_id, machine_master_id: row.machine_id, machine_ids: row.submachines.map((s) => s.machine_id), quantity: row.quantity, priority: row.priority, fetch_list_ids, status: row.status, machine_status: 'scheduled' });
        }
      });
    });
    return { workflow_creation_id: workflowId, name: form.name.trim(), status: form.status, job_machines: allJobMachines };
  };

  // ── Preview ──────────────────────────────────────────────────────────────
  const handlePreview = async () => {
    if (!validate()) { enqueueSnackbar('Please fix validation errors', { variant: 'error' }); return; }
    setPreviewLoading(true);
    try {
      const payload = AutobuildPayload();
      const res = await postFetcher(['factoryLayout-app/preview-auto-job/', payload]);
      setPreviewData(res);
      setIsPreviewMode(true);
      if (res.job_machines) {
        const updatedRows = { ...nodeMachineRows };
        res.job_machines.forEach((jobMachine) => {
          const nodeId = jobMachine.node_id.toString();
          if (updatedRows[nodeId]) {
            updatedRows[nodeId] = updatedRows[nodeId].map((row) => {
              if (row.machine_id === jobMachine.machine_master_id) {
                const selectedSubmachines = [];
                if (jobMachine.machine_ids?.length > 0) {
                  jobMachine.machine_ids.forEach((machineId) => {
                    const submachine = (allSubmachines[nodeId] || []).find((s) => s.machine_id === machineId);
                    if (submachine) selectedSubmachines.push(submachine);
                  });
                }
                return { ...row, submachines: selectedSubmachines, quantity: jobMachine.quantity || [] };
              }
              return row;
            });
          }
        });
        setNodeMachineRows(updatedRows);
      }
      enqueueSnackbar('Preview generated successfully', { variant: 'success' });
    } catch (e) {
      console.error(e);
      enqueueSnackbar(e.response?.data?.message || 'Preview failed', { variant: 'error' });
    } finally { setPreviewLoading(false); }
  };

  // ── Create from preview ──────────────────────────────────────────────────
  const handleCreateFromPreview = async () => {
    setLoading(true); setSaveError(''); setInventoryReport([]);
    try {
      const payload = buildPayload();
      const res = await postFetcher(['factoryLayout-app/jobs/create/', payload]);
      setjobId(res?.id);
      const report = res?.inventory_availability || [];
      setInventoryReport(report);
      if (report.length > 0 && report.some((r) => r.shortage_qty > 0)) {
        setWarningData(report); setShowWarningDialog(true);
      } else {
        enqueueSnackbar('Job created successfully', { variant: 'success' });
        handleClose(); router.push(paths.dashboard.kanban); onJobSaved(res);
      }
    } catch (e) { setSaveError(e.response?.data?.message || 'Failed to save job'); }
    finally { setLoading(false); }
  };

  // ── Save ─────────────────────────────────────────────────────────────────
  const handleSave = async () => {
    setLoading(true); setSaveError(''); setInventoryReport([]);
    try {
      const payload = buildPayload();
     
      const res = await postFetcher(['factoryLayout-app/jobs/create/', payload]);
      setjobId(res?.id);
      const report = res?.inventory_availability || [];
      setInventoryReport(report);
      if (report.length > 0 && report.some((r) => r.shortage_qty > 0)) {
         updatejobpayload(payload)
        setWarningData(report); setShowWarningDialog(true);
      } else {
        enqueueSnackbar('Job created successfully', { variant: 'success' });
        handleClose(); router.push(paths.dashboard.kanban); onJobSaved(res);
      }
    } catch (e) { setSaveError(e.response?.data?.message || 'Failed to save job'); }
    finally { setLoading(false); }
  };

  const handleAutomaticSave = async () => {
    setLoading(true); setSaveError(''); setInventoryReport([]);
    try {
      const payload = AutobuildPayload();
      const res = await postFetcher(['factoryLayout-app/preview-auto-job/', payload]);
      setjobId(res?.id);
      const report = res?.inventory_availability || [];
      setInventoryReport(report);
      if (report.length > 0 && report.some((r) => r.shortage_qty > 0)) {
        setWarningData(report); setShowWarningDialog(true);
      } else {
        enqueueSnackbar('Job auto-scheduled successfully', { variant: 'success' });
        handleClose(); onJobSaved(res);
      }
    } catch (e) {
      console.error(e);
      enqueueSnackbar(e.response?.data?.message || 'Auto-scheduling failed', { variant: 'error' });
      setSaveError(e.response?.data?.message || 'Failed');
    } finally { setLoading(false); }
  };

  const handleClose = () => {
    if (!loading && !previewLoading) { resetForm(); handleCloseJobDialog(); }
  };

  const resetForm = () => {
    setForm({ name: '', productCreationId: null, status: 'scheduled' });
    setErrors({}); setSaveError(''); setNodeMachineRows({}); setAllNodeData({});
    setAllSubmachines({}); setPreviewData(null); setIsPreviewMode(false);
    setActiveSection('details');
  };

  // ── Section: Job Details ─────────────────────────────────────────────────
  const renderDetailsSection = () => (
    <Box>
      {/* Job Name card */}
      <Box sx={cardStyle}>
        <Box sx={cardHeaderStyle}>
          <Box sx={sectionTitleStyle}>
            <span style={{ color: '#6B7280' }}>📋</span> Job Information
          </Box>
        </Box>
        <Box sx={{ px: 2.5, py: 2 }}>
          <TextField
            fullWidth
            label="Job Name"
            value={form.name}
            onChange={handleFormChange('name')}
            error={!!errors.name}
            helperText={errors.name || 'Enter a unique name for this job'}
            disabled={loading || previewLoading}
            size="small"
            sx={{ mb: 0, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
          />
        </Box>
      </Box>

      {/* Scheduling Mode card */}
      <Box sx={cardStyle}>
        <Box sx={cardHeaderStyle}>
          <Box sx={sectionTitleStyle}>
            <span style={{ color: '#6B7280' }}>⚡</span> Scheduling Mode
          </Box>
        </Box>
        <Box sx={{ px: 2.5, py: 2 }}>
          <RadioGroup
            row
            value={schedulingMode}
            onChange={(e) => {
              if (!loading && !previewLoading) {
                setSchedulingMode(e.target.value);
                setIsPreviewMode(false);
                setPreviewData(null);
              }
            }}
          >
            <FormControlLabel
              value="manual"
              control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#111827' } }} />}
              label={
                <Box>
                  <Typography variant="body2" fontWeight={600} color="#111827">Manual</Typography>
                  <Typography variant="caption" color="text.secondary">Select submachines yourself</Typography>
                </Box>
              }
              disabled={loading || previewLoading}
              sx={{
                mr: 4,
                alignItems: 'flex-start',
                border: schedulingMode === 'manual' ? '1.5px solid #111827' : '1.5px solid #E5E7EB',
                borderRadius: '8px', px: 1.5, py: 1, mr: 2,
                backgroundColor: schedulingMode === 'manual' ? '#F9FAFB' : 'transparent',
              }}
            />
            <FormControlLabel
              value="auto"
              control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#111827' } }} />}
              label={
                <Box>
                  <Typography variant="body2" fontWeight={600} color="#111827">Auto SubMachine</Typography>
                  <Typography variant="caption" color="text.secondary">System picks optimal machines</Typography>
                </Box>
              }
              disabled={loading || previewLoading}
              sx={{
                alignItems: 'flex-start',
                border: schedulingMode === 'auto' ? '1.5px solid #111827' : '1.5px solid #E5E7EB',
                borderRadius: '8px', px: 1.5, py: 1,
                backgroundColor: schedulingMode === 'auto' ? '#F9FAFB' : 'transparent',
              }}
            />
          </RadioGroup>
        </Box>
      </Box>

      {/* Preview banner */}
      {isPreviewMode && previewData && (
        <Box sx={{ border: '1px solid #DBEAFE', borderRadius: '10px', p: 2, backgroundColor: '#EFF6FF', mb: 2 }}>
          <Typography variant="body2" fontWeight={700} color="#1D4ED8" sx={{ mb: 0.5 }}>
            Preview Mode Active
          </Typography>
          <Typography variant="body2" color="#3B82F6">
            You can now modify the auto-selected submachines and quantities before creating the job.
          </Typography>
          {previewData.is_fully_available !== undefined && (
            <Typography variant="body2" sx={{ mt: 0.5 }} color={previewData.is_fully_available ? '#059669' : '#D97706'} fontWeight={600}>
              Inventory: {previewData.is_fully_available ? '✓ Fully Available' : '⚠ Shortages Detected'}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );

  // ── Section: Nodes ───────────────────────────────────────────────────────
  const renderNodeSection = (nodeId) => {
    const nodeData = allNodeData[nodeId];
    const machineRows = nodeMachineRows[nodeId] || [];
    const nodeSubmachines = allSubmachines[nodeId] || [];
    const isLoading = loadingSubmachines[nodeId];

    if (!nodeData) {
      return (
        <Box key={nodeId} sx={{ ...cardStyle, border: '1px solid #FECACA' }}>
          <Box sx={{ px: 2.5, py: 2 }}>
            <Typography color="error" variant="body2">Failed to load data for node {nodeId}</Typography>
          </Box>
        </Box>
      );
    }

    const nodeIcon = nodeData.type === 'diamond' ? '💎' : '⚙️';
    const headerBg = nodeData.type === 'diamond' ? '#FDF4FF' : '#F9FAFB';
    const headerBorder = nodeData.type === 'diamond' ? '#E9D5FF' : '#E5E7EB';

    return (
      <Box key={nodeId} sx={{ ...cardStyle, border: `1px solid ${headerBorder}` }}>
        <Box sx={{ ...cardHeaderStyle, backgroundColor: headerBg, borderBottom: `1px solid ${headerBorder}` }}>
          <Box sx={sectionTitleStyle}>
            <span>{nodeIcon}</span>
            {nodeData.name}
            <Chip
              label={`ID: ${nodeId}`}
              size="small"
              sx={{ fontSize: '10px', height: '18px', backgroundColor: '#E5E7EB', color: '#6B7280', ml: 0.5 }}
            />
          </Box>
          <Chip
            label={nodeData.type}
            size="small"
            sx={{ fontSize: '10px', height: '20px', backgroundColor: nodeData.type === 'diamond' ? '#F3E8FF' : '#F3F4F6', color: nodeData.type === 'diamond' ? '#7C3AED' : '#374151', fontWeight: 600, textTransform: 'capitalize' }}
          />
        </Box>

        <Box sx={{ px: 2.5, py: 2 }}>
          {machineRows.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 3 }}>
              <Typography variant="body2" color="text.secondary">No machines configured for this node</Typography>
            </Box>
          ) : (
            machineRows.map((row, idx) => {
              const errorKey = `submachines_${nodeId}_${idx}`;

              if (row.is_diamond_node) {
                return (
                  <Box key={`${nodeId}-${idx}`} sx={{ border: '1px dashed #C4B5FD', borderRadius: '8px', p: 2, backgroundColor: '#FAF5FF' }}>
                    <Typography variant="body2" fontWeight={600} color="#7C3AED" gutterBottom>💎 {row.machine_name}</Typography>
                    <Typography variant="caption" color="#A78BFA">Diamond node — No machine configuration required</Typography>
                    <Box sx={{ mt: 1 }}>
                      <Chip label={`Status: ${row.diamond_status}`} size="small" sx={{ backgroundColor: '#EDE9FE', color: '#7C3AED', fontSize: '11px' }} />
                    </Box>
                  </Box>
                );
              }

              if (row.is_default_node) {
                return (
                  <Box key={`${nodeId}-${idx}`} sx={{ border: '1px dashed #6EE7B7', borderRadius: '8px', p: 2, backgroundColor: '#F0FDF4' }}>
                    <Typography variant="body2" fontWeight={600} color="#059669" gutterBottom>⚙️ {row.machine_name}</Typography>
                    <Typography variant="caption" color="#34D399">Default node — No machine configuration required</Typography>
                    <Box sx={{ mt: 1 }}>
                      <Chip label="Auto-completed" size="small" sx={{ backgroundColor: '#D1FAE5', color: '#059669', fontSize: '11px' }} />
                    </Box>
                  </Box>
                );
              }

              return (
                <Box key={`${nodeId}-${idx}`} sx={{ border: '1px solid #E5E7EB', borderRadius: '8px', p: 2, mb: idx < machineRows.length - 1 ? 1.5 : 0 }}>
                  <Typography variant="body2" fontWeight={600} color="#374151" sx={{ mb: 1.5 }}>
                    {row.machine_name}
                  </Typography>
                  <Grid container spacing={1.5}>
                    {(schedulingMode === 'auto' || schedulingMode === 'manual') && (
                      <Grid item xs={12}>
                        <Autocomplete
                          multiple
                          options={nodeSubmachines.filter((s) => s.machine_master_id === row.machine_id)}
                          getOptionLabel={(o) => o.machine_label || o.label || ''}
                          value={row.submachines}
                          onChange={(_, v) => handleSubmachinesChange(nodeId, idx, _, v)}
                          loading={isLoading}
                          disabled={loading || previewLoading}
                          size="small"
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const { key, ...tagProps } = getTagProps({ index });
                              return (
                                <Chip
                                  key={key}
                                  label={option.machine_label || 'Submachine'}
                                  size="small"
                                  color={option.active_scheduled_jobs_count > 0 ? 'warning' : 'primary'}
                                  variant="soft"
                                  {...tagProps}
                                  title={`${option.active_scheduled_jobs_count} active job(s) running`}
                                  avatar={
                                    option.active_scheduled_jobs_count > 0 ? (
                                      <Avatar sx={{ width: 20, height: 20, fontSize: '0.7rem', bgcolor: 'error.main' }}>
                                        {option.active_scheduled_jobs_count}
                                      </Avatar>
                                    ) : undefined
                                  }
                                />
                              );
                            })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Submachines"
                              error={!!errors[errorKey]}
                              helperText={errors[errorKey] || 'Select submachines'}
                              size="small"
                              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>{isLoading && <CircularProgress size={16} />}{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Box>
              );
            })
          )}
        </Box>
      </Box>
    );
  };

  const renderNodesSection = () => (
    <Box>
      {nodeIds.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 6, border: '2px dashed #E5E7EB', borderRadius: '10px' }}>
          <Typography variant="body2" color="text.secondary">No nodes selected for job scheduling</Typography>
        </Box>
      ) : (
        <>
          <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={`${nodeIds.length} node${nodeIds.length > 1 ? 's' : ''}`}
              size="small"
              sx={{ backgroundColor: '#F3F4F6', color: '#374151', fontWeight: 600, fontSize: '11px' }}
            />
          </Box>
          {nodeIds.map((nodeId) => renderNodeSection(nodeId))}
        </>
      )}
    </Box>
  );

  // ── Section: Schedule ────────────────────────────────────────────────────
  const renderScheduleSection = () => (
    <Box>
      <Box sx={cardStyle}>
        <Box sx={cardHeaderStyle}>
          <Box sx={sectionTitleStyle}><span style={{ color: '#6B7280' }}>📅</span> Schedule Settings</Box>
        </Box>
        <Box sx={{ px: 2.5, py: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Additional scheduling options can be configured here.
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  const sectionContent = {
    details: renderDetailsSection(),
    nodes: renderNodesSection(),
    schedule: renderScheduleSection(),
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <Dialog
        open={JobDialogOpen}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
            maxHeight: '88vh',
          },
        }}
      >
        {/* ── Header ── */}
        <Box sx={{ px: 3, pt: 2.5, pb: 2, borderBottom: '1px solid #F3F4F6' }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Box>
              <Typography variant="h6" fontWeight={700} fontSize="17px" color="#111827">
                {jobData ? 'Edit Job' : 'New Job'}
                {isPreviewMode && (
                  <Chip label="Preview" size="small" sx={{ ml: 1, fontSize: '10px', height: '20px', backgroundColor: '#DBEAFE', color: '#1D4ED8', fontWeight: 700 }} />
                )}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Configure workflow job for {nodeIds.length} node{nodeIds.length !== 1 ? 's' : ''}
              </Typography>
            </Box>
            <IconButton
              onClick={handleClose}
              disabled={loading || previewLoading}
              size="small"
              sx={{ color: '#9CA3AF', '&:hover': { backgroundColor: '#F3F4F6', color: '#374151' }, mt: -0.5 }}
            >
              <IconClose />
            </IconButton>
          </Box>
        </Box>

        {/* ── Body: sidebar + content ── */}
        <Box sx={{ display: 'flex', height: '100%', minHeight: 0, flex: 1 }}>
          {/* Sidebar */}
          <Box sx={sidebarStyle}>
            <Typography sx={sectionLabelStyle}>Sections</Typography>
            {NAV_ITEMS.map((item) => (
              <Box
                key={item.id}
                onClick={() => setActiveSection(item.id)}
                sx={navItemStyle(activeSection === item.id)}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', opacity: activeSection === item.id ? 1 : 0.7 }}>
                  {item.icon}
                </Box>
                <Typography variant="body2" fontWeight={activeSection === item.id ? 600 : 500} fontSize="13px">
                  {item.label}
                </Typography>
                {item.id === 'nodes' && nodeIds.length > 0 && (
                  <Box sx={{ ml: 'auto', width: 18, height: 18, borderRadius: '50%', backgroundColor: activeSection === 'nodes' ? 'rgba(255,255,255,0.25)' : '#E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="caption" fontSize="9px" fontWeight={700} color={activeSection === 'nodes' ? '#fff' : '#6B7280'}>
                      {nodeIds.length}
                    </Typography>
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2.5 }}>
            {saveError && (
              <Alert severity="error" sx={{ mb: 2, borderRadius: '8px' }} onClose={() => setSaveError('')}>
                {saveError}
              </Alert>
            )}
            {sectionContent[activeSection]}
          </Box>
        </Box>

        {/* ── Footer ── */}
        <Box sx={{ px: 3, py: 2, borderTop: '1px solid #F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#FAFAFA' }}>
          {/* left: final product checkbox placeholder (matching design) */}
          <Box />

          {/* right: actions */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              onClick={handleClose}
              disabled={loading || previewLoading}
              size="small"
              sx={{
                color: '#374151', backgroundColor: '#fff', border: '1px solid #E5E7EB',
                borderRadius: '8px', px: 2, textTransform: 'none', fontWeight: 600, fontSize: '13px',
                '&:hover': { backgroundColor: '#F9FAFB' },
              }}
            >
              Cancel
            </Button>

            {schedulingMode === 'manual' && (
              <Button
                onClick={handleSave}
                variant="contained"
                disabled={loading || previewLoading || nodeIds.length === 0}
                size="small"
                startIcon={loading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : null}
                sx={{
                  backgroundColor: '#111827', color: '#fff', borderRadius: '8px',
                  px: 2, textTransform: 'none', fontWeight: 600, fontSize: '13px',
                  boxShadow: 'none', '&:hover': { backgroundColor: '#1F2937', boxShadow: 'none' },
                }}
              >
                {loading ? 'Saving...' : 'Create Job'}
              </Button>
            )}

            {schedulingMode === 'auto' && !isPreviewMode && (
              <Button
                onClick={handlePreview}
                disabled={previewLoading || nodeIds.length === 0 || !form.name.trim()}
                size="small"
                startIcon={previewLoading ? <CircularProgress size={14} /> : <IconPreview />}
                sx={{
                  backgroundColor: '#111827', color: '#fff', borderRadius: '8px',
                  px: 2, textTransform: 'none', fontWeight: 600, fontSize: '13px',
                  boxShadow: 'none', '&:hover': { backgroundColor: '#1F2937', boxShadow: 'none' },
                  '&:disabled': { backgroundColor: '#E5E7EB', color: '#9CA3AF' },
                }}
              >
                {previewLoading ? 'Generating...' : 'Preview Auto Schedule'}
              </Button>
            )}

            {schedulingMode === 'auto' && isPreviewMode && (
              <>
                <Button
                  onClick={() => setIsPreviewMode(false)}
                  disabled={loading}
                  size="small"
                  sx={{
                    color: '#374151', backgroundColor: '#fff', border: '1px solid #E5E7EB',
                    borderRadius: '8px', px: 2, textTransform: 'none', fontWeight: 600, fontSize: '13px',
                    '&:hover': { backgroundColor: '#F9FAFB' },
                  }}
                >
                  ← Back to Edit
                </Button>
                <Button
                  onClick={handleCreateFromPreview}
                  disabled={loading || nodeIds.length === 0}
                  size="small"
                  startIcon={loading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : null}
                  sx={{
                    backgroundColor: '#059669', color: '#fff', borderRadius: '8px',
                    px: 2, textTransform: 'none', fontWeight: 600, fontSize: '13px',
                    boxShadow: 'none', '&:hover': { backgroundColor: '#047857', boxShadow: 'none' },
                  }}
                >
                  {loading ? 'Creating...' : 'Create Job from Preview'}
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Dialog>

      <QuantityWarningDialog
        open={showWarningDialog}
        onClose={() => setShowWarningDialog(false)}
        report={warningData}
        jobId={jobId}
        onConfirmPO={() => {
          enqueueSnackbar('PO generation coming soon!', { variant: 'info' });
          setShowWarningDialog(false);
          handleClose();
        }}
        setWarningData={setWarningData}
      />
    </>
  );
}